import { useState } from 'react'

import { FvButton, Icon } from '@fv/client-components'
import type { FullShipment } from '@fv/client-types'

import { Pinline } from '@/components/Pinline'
import { ShipperSlider } from '@/components/ShipperSlider'
import { RouteGuidePanel } from '@/features/shipment-details-panel/RouteGuidePanel'

import { hasRouteGuide } from './funcs'
import type { RouteGuideView } from './hooks'
import { RouteGuideOverview } from './RouteGuideOverview'
import type { RouteGuideStep } from './RouteGuideProgress'

type Props = {
  load?: FullShipment
  view: RouteGuideView
  selectedCarrierId?: string
  onStepClick: (step: RouteGuideStep) => void
}

export const RouteGuideQuoteSection = ({ load, ...props }: Props) => {
  if (!load || !hasRouteGuide(load)) {
    return null
  }

  if (load.routeGuide?.status === 'exhausted') {
    return <RouteGuideExhaustedHeader load={load} />
  }

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <RouteGuideOverview load={load} {...props} />
    </div>
  )
}

const RouteGuideExhaustedHeader = ({ load }: { load: FullShipment }) => {
  const [isOpen, setOpen] = useState(false)

  return (
    <>
      <div className="flex items-center gap-x-2 border-b border-fv-gray px-6 py-4">
        <Icon icon="ban" className="text-fv-orange-bright" />
        <span>
          Route guide exhausted - this shipment is now open for spot quotes.
        </span>
        <Pinline className="flex-1 min-w-8" dotted />
        <FvButton icon="list" theme="underlined" onClick={() => setOpen(true)}>
          View route guide
        </FvButton>
      </div>

      <ShipperSlider flush isOpen={isOpen} onClose={() => setOpen(false)}>
        <RouteGuidePanel load={load} setActiveSlider={() => setOpen(false)} />
      </ShipperSlider>
    </>
  )
}
